import moment from "moment";
import momentTimezone from "moment-timezone";
import { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { $Values } from "utility-types";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import { customDateFormats } from "../../../../localization/translations";
export const DateFormatsTypes = {
  EVENT: "event-overview",
  REPORT: "report-date",
  DATE_DDMMYYYY: "date-DD/MM/YYYY",
  TIME_HHmm: "time-HH:mm",
  DATE_MDD: "date-DD/MM",
};

type Props = {
  value: string;
  dateFormat?: $Values<typeof DateFormatsTypes>;
  timezone: Record<string, any>;
};

class MomentDate extends Component<Props> {
  static defaultProps = {
    dateFormat: DateFormatsTypes.EVENT,
  };

  render() {
    const { value, dateFormat, timezone } = this.props;
    if (value === null || value === undefined) {
      return "";
    }
    // Get the custom date formats for the current language
    const currentLanguageFormat = customDateFormats[moment.locale()];
    // Get event-overview date format
    const format = currentLanguageFormat[dateFormat];
    return (
      <Moment format={format}>
        {SessionHelper.isAsianRouteAndSessionView()
          ? momentTimezone(value).tz(timezone.name)
          : value}
      </Moment>
    );
  }
}

const mapStateToProps = state => ({
  timezone: state.userModel.timezone,
});

export default connect(mapStateToProps)(MomentDate) as any;
